import React, { useEffect } from 'react'
import { Link } from "react-router-dom";
import NavBar from '../Common/Navbar'
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';

import { AiFillHome } from "react-icons/ai";
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";


function Contact() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>Let's Talk To Us</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/Contact">Contact Us</Link>
                    </div>
                </div>
            </div>
            <div className="contact">
                <div className="container pt-5">
                    <form id="contact-form">
                        <div className="d-flex gap-md-5 gap-sm-5 gap-5 flex-md-row flex-sm-column flex-column">
                            <input type="text" placeholder='Name' required />
                            <input type="text" placeholder='Phone Number' required />
                        </div>
                        <div className="d-flex gap-md-5 gap-sm-5 gap-5 flex-md-row flex-sm-column flex-column">
                            <input type="email" placeholder='Email' required />
                            <input type="text" placeholder='Address' required />
                        </div>
                        <div>
                            <textarea rows="3" placeholder='Message' required></textarea>
                        </div>
                        <a href="#" className="btn_1 w-100 text-center mt-5" >Send Message</a>
                    </form>
                    <div className="contact-address d-flex flex-md-row flex-sm-column flex-column justify-content-center align-items-md-center align-items-sm-start align-items-start gap-lg-0 gap-md-2 gap-sm-2 gap-2">
                        <div className="d-flex align-items-center gap-lg-4 gap-md-3 gap-sm-3">
                            <AiFillHome className='icon-address' />
                            <a href="#" className='text-decoration-none' style={{ color: '#ffffff' }}>Johar Town Phase02 Lahore Pakistan</a>
                        </div>
                        <div><hr /></div>
                        <div className="d-flex align-items-center gap-lg-4 gap-md-3 gap-sm-3">
                            <FaPhone className='icon-address' />
                            <a href="#" className='text-decoration-none' style={{ color: '#ffffff' }}>+92 3069126229</a>
                        </div>
                        <div><hr /></div>
                        <div className="d-flex align-items-center gap-lg-4 gap-md-3 gap-sm-3">
                            <IoMdMail className='icon-address' />
                            <a href="#" className='text-decoration-none' style={{ color: '#ffffff' }}>abdullahkhalid7892@gmail.com</a>
                        </div>
                    </div>
                    <h2>Find Us Here</h2>
                </div>
            </div>
            <div className="map">
                <div className="map-outer">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27225.81796107276!2d74.2424419195999!3d31.462934457740214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391901806ea024bf%3A0xfe60e8b92748c353!2sPhase%202%20Johar%20Town%2C%20Lahore%2C%20Punjab%2C%20Pakistan!5e0!3m2!1sen!2s!4v1731434999943!5m2!1sen!2s" width="100%" height="470px" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" style={{ border: '0' }}></iframe>
                    
                </div>
            </div>
            <FooterMenu />
            <Copyright />
        </>
    )
}

export default Contact
